import script from "./DesktopFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopFooter.vue?vue&type=script&setup=true&lang=js"

import "./DesktopFooter.vue?vue&type=style&index=0&id=6bacccc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bacccc0"]])

export default __exports__